import { ExpandedTooltip, getUtility } from '@livable/saas-react-components';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import useStyles from './styles';
export default function AllocationCounter(_ref) {
  let billStatus = _ref.billStatus,
    statementDate = _ref.statementDate,
    status = _ref.status;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const titleBody = header => {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "tooltip-header"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, header)), /*#__PURE__*/React.createElement("div", {
      className: "tooltip-content"
    }, status.length > 0 ? status.map(utility => /*#__PURE__*/React.createElement("div", {
      className: classes.utility,
      key: uuid()
    }, getUtility(utility).icon(), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, utility))) : /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, t('allocations.no_utilities_for_this_status'))));
  };
  const statementsBody = props => {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "tooltip-header"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, props.header)), /*#__PURE__*/React.createElement("div", {
      className: "tooltip-content"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, props.text)));
  };
  const child = className => {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.counter, " ").concat(className)
    }, status.length);
  };
  const tooltipObj = {
    PendingApproval: {
      class: classes.infoCounter,
      header: t('allocations.pending_approval'),
      type: 'utilities-info'
    },
    PendingCompletion: {
      class: classes.warningCounter,
      header: t('allocations.pending_completion'),
      type: 'utilities-warning'
    },
    TableReady: {
      class: classes.successCounter,
      header: t('allocations.allocation_tables_ready'),
      type: 'utilities-success'
    },
    TableReadyStatementSent: {
      class: classes.successBoldCounter,
      header: t('allocations.statements_sent_hint'),
      text: t('allocations.statements_were_sent_on', {
        interpolation: {
          escapeValue: false
        },
        statementDate
      }),
      type: 'utilities-success-bold'
    },
    TableSkipped: {
      class: classes.errorCounter,
      header: t('allocations.skipped'),
      text: t('allocations.tables_are_set_to_be_skipped'),
      type: 'utilities-error'
    }
  };
  let title = titleBody(tooltipObj[billStatus].header);
  if (billStatus === 'TableSkipped' || billStatus === 'TableReadyStatementSent') {
    title = statementsBody(tooltipObj[billStatus]);
  }
  return /*#__PURE__*/React.createElement(ExpandedTooltip, {
    children: child(tooltipObj[billStatus].class),
    placement: "top",
    title: title,
    type: tooltipObj[billStatus].type
  });
}